import {EntityWithAuditMetadata} from '../../../../common/entity/entityWithAuditMetadata';
import {SummaryModel} from '../../../../common/entity/summary.model';

export class InsoleCadProcessSummaryModel extends EntityWithAuditMetadata implements SummaryModel {
    id: number;
    v3: boolean;
    data: any;
}
